import PropTypes from "prop-types";
import { commonPropTypes } from "../entities-selector";

export default {
  ...commonPropTypes,
  /**
   * Id del contrato del que depende
   */
  contractId: PropTypes.string,
};
